import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import logo from 'images/Alphaeon_Patient_Financing_Logo.png';
function TreatmentEstimateHeader() {
    return (_jsx("div", { className: "treatment-estimate__header", children: _jsx("img", { src: logo, className: "logo", alt: "Alphaeon Patient Financing" }) }));
}
export default memo(TreatmentEstimateHeader);
